import { Component } from '@angular/core';
import { BaseMenuComponent } from '../base.menu';
import { ModalComponent } from '../../modal/modal.component';

@Component({
    templateUrl: 'edit-discussion.menu.html',
    standalone: false
})
export class EditDiscussionMenuComponent extends BaseMenuComponent {
  constructor(public modal: ModalComponent) {
    super(modal);
    this.modal.hasClassModal = true;
  }
}
